<!-- 打包页面菜品展示 -->
<template>
  <div class="home flexBox" v-if="isAll">
    <van-nav-bar
      :style="{ background: sessionStorage.colorCode }"
      :title="$t('Home.pickup')"
      left-arrow
      fixed
      @click-left="$router.go(-1)"
      :right-text="$t('PlaceOrderDetail.orderList')"
      @click-right="$router.push('/PackOrderList')"
    >
    </van-nav-bar>
    <div class="contentWrapper">
      <div v-if="dishes" class="menuContent">
        <van-sidebar v-model="activeKey" @change="changeKey()">
          <template v-for="(dish, index) in dishes">
            <van-sidebar-item
              :title="dish.name"
              :key="index"
              :style="
                activeKey == index
                  ? {
                      'background-color': sessionStorage.colorCode,
                      'border-color': sessionStorage.colorCode
                    }
                  : {}
              "
            ></van-sidebar-item>
          </template>
        </van-sidebar>
        <div class="dishContent">
          <!-- 有产品 -->
          <template v-if="actMenus.length > 0">
            <div
              v-for="(menu, index) in actMenus"
              class="dishItem"
              :key="menu.id"
            >
              <div
                @click.stop="
                  menu.category == 'm'
                    ? $router.push('/PackDishesDetail/' + menu.id)
                    : $router.push('/PackageDishesDetail/' + menu.id)
                "
              >
                <template v-if="menu.image">
                  <van-image class="noflex" :src="menu.image.path" />
                </template>
                <template v-else>
                  <van-image class="noflex" :src="sessionStorage.images" />
                </template>
              </div>
              <div
                class="itemInfo"
                @click.stop="
                  menu.category == 'm'
                    ? $router.push('/PackDishesDetail/' + menu.id)
                    : $router.push('/PackageDishesDetail/' + menu.id)
                "
              >
                <div class="leftInfo">
                  <div class="fontLine noExceed Bigfont">{{ menu.name }}</div>
                  <div class="fontLine noExceed Subname">
                    {{ menu.name_en }}
                  </div>
                  <div
                    class="fontLine noExceed Subname"
                    v-if="menu.introduction"
                  >
                    {{ menu.introduction }}
                  </div>
                  <div style="height: 5px"></div>
                  <!-- <van-rate
                    readonly
                    v-model="menu.level"
                    :size="12"
                    gutter="1px"
                    icon="./static/img/Recommend-s.png"
                    void-icon="./static/img/Recommend.png"
                  /> -->
                  <div class="dishItem_footer">
                    <div class="fontLine noExceed price_num">
                      <div
                        v-if="
                          menu.original_price || menu.special_price !== null
                        "
                      >
                        <span class="currentPrice"
                          >{{ sessionStorage.getItem("currency")
                          }}{{
                            menu.type == "o"
                              ? menu.original_price
                              : menu.special_price
                          }}</span
                        >&nbsp;<span class="oldPrice" v-show="menu.type == 's'"
                          >{{ sessionStorage.getItem("currency")
                          }}{{ menu.original_price }}</span
                        >
                      </div>
                      <div class="currentPrice" v-else>
                        {{ sessionStorage.getItem("currency") }}0
                      </div>
                    </div>
                    <div
                      class="icons"
                      v-if="sessionStorage.getItem('is_quick') == '1'"
                      @click.stop
                    >
                      <van-stepper
                        default-value="0"
                        min="0"
                        integer
                        v-model="menu.count"
                        button-size="22"
                        @plus="addDish(menu.id, index, 1)"
                        @minus="subDish(menu.id, index, 1)"
                        @focus="focusDish(menu.id, index, menu.count)"
                        @blur="blurDish(menu.id, index, menu.count)"
                        ref="input"
                        allow-empty
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- 没产品 -->
          <template v-else>
            <div style="text-align: center;line-height: 80px;">
              {{ $t("Dishes.nonefood") }}
            </div>
          </template>
        </div>
      </div>
      <!-- 购物车菜品 -->
      <van-popup
        class="ShopCartBox"
        v-model="isShopCartShow"
        position="bottom"
        :style="{ height: '75%' }"
      >
        <van-cell-group class="cartHeader">
          <van-cell>
            <div
              style="font-size: 18px; font-weight: 600; color: #000"
              slot="title"
            >
              <van-icon
                slot="left-icon"
                name="./static/img/toback.png"
                size="16px"
                @click="isShopCartShow = false"
              />
              <!-- {{ $t("Dishes.cart") }} -->
              {{ $t("Dishes.myCart") }}[ {{ shopCart.count }} ]
            </div>
            <van-icon
              slot="right-icon"
              name="./static/img/empty.png"
              size="26px"
              @click="chearShopcart"
            />
          </van-cell>
        </van-cell-group>
        <div class="cartDetail" v-if="shopCart.data">
          <template v-for="(dish, index) in shopCart.data">
            <div class="cartItem" :key="index">
              <!-- 产品 -->
              <div class="cart_dish">
                <div class="dish noExceed">
                  <template v-if="dish.image">
                    <van-image
                      class="menuImg"
                      width="70"
                      height="70"
                      :src="dish.image.path"
                    />
                  </template>
                  <template v-else>
                    <van-image
                      class="menuImg"
                      width="70"
                      height="70"
                      :src="sessionStorage.images"
                    />
                  </template>
                  <div style="margin-left: 10px; width: calc(100% - 80px);">
                    <div class="menu_name">{{ dish.menu_name }}</div>
                    <div class="cart_dish_des noExceed">
                      <template
                        v-if="dish.menus_name.length == 0 && dish.tags_name"
                      >
                        <span
                          v-for="(tagName, index) in dish.tags_name"
                          :key="index"
                        >
                          {{ tagName }}，
                        </span>
                      </template>
                      <span
                        v-if="
                          dish.menus_name.length == 0 && dish.remark[0] != ''
                        "
                        >{{ $t("PackageDetail.remark") }}：</span
                      >
                      <template
                        v-if="
                          dish.menus_name.length == 0 && dish.remark[0] != ''
                        "
                      >
                        ({{ dish.remark[0] }})
                      </template>
                    </div>
                    <div
                      style="display: flex; align-items: center; justify-content: space-between;"
                    >
                      <div class="realPrice">
                        {{ sessionStorage.getItem("currency") }}{{ dish.price }}
                      </div>
                      <!-- 加减和价格 -->
                      <div class="icon_group">
                        <div class="cart_dish_icon fl">
                          <van-icon
                            class="reduceBtn"
                            :style="{
                              border: `1px solid ${sessionStorage.colorCode}`
                            }"
                            name="./static/img/reduce.png"
                            size="10px"
                            @click="subShopCart(dish.id, dish.number)"
                          ></van-icon>
                          <span
                            style="
                              display: inline-block;
                              min-width: 30px;
                              height: 30px;
                              text-align: center;
                              line-height: 30px;
                              vertical-align: top;
                            "
                          >
                            {{ dish.number }}
                          </span>
                          <van-icon
                            class="addBtn"
                            :style="{ background: sessionStorage.colorCode }"
                            name="./static/img/add.png"
                            size="12px"
                            @click="addShopCart(dish.id)"
                          ></van-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 套餐 -->
                <div v-if="dish.menus_name">
                  <div
                    class="cart_dish son_dish"
                    v-for="(menu, key) in dish.menus_name"
                    :key="key"
                  >
                    <div
                      v-if="typeof menu == 'object'"
                      class="cart_dish_name noExceed fl"
                    >
                      <template v-for="(menuArr, i) in menu">
                        {{ menuArr }}{{ i == menu.length - 1 ? "" : "、" }}
                      </template>
                    </div>
                    <div v-else class="cart_dish_name noExceed fl">
                      {{ menu }}
                    </div>

                    <div
                      v-if="typeof menu == 'object'"
                      class="cart_dish_price noExceed fl"
                    >
                      {{ sessionStorage.getItem("currency") }}
                      <template v-for="(priceArr, j) in dish.fill_price[key]">
                        {{ j == 0 ? priceTotal(dish.fill_price[key]) : "" }}
                      </template>
                    </div>
                    <div v-else class="cart_dish_price noExceed fl">
                      {{ sessionStorage.getItem("currency")
                      }}{{ dish.fill_price[key] }}
                    </div>
                    <div class="cart_dish_des noExceed fl">
                      <template v-if="dish.tags_name[key]">
                        <template v-if="typeof dish.tags_name[key] == 'object'">
                          <template v-for="(tagName, i) in dish.tags_name[key]">
                            <template v-if="typeof tagName == 'object'">
                              {{ arrShow(tagName) }}
                            </template>
                            <template v-else>
                              {{ tagName }}
                            </template>
                            <template v-if="dish.remark[key][i]">
                              ({{ dish.remark[key][i]
                              }}{{
                                i == dish.remark[key].length - 1 ||
                                !dish.remark[key][i]
                                  ? ""
                                  : ""
                              }})
                            </template>
                            &nbsp;&nbsp;
                          </template>
                        </template>
                        <template v-else>
                          {{ dish.tags_name[key] }}
                          <template v-if="dish.remark[key]">
                            ({{ dish.remark[key] }})
                          </template>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <van-divider style="margin: 10px 0;" />
          </template>
          <div style="height: 50px;"></div>
        </div>
        <van-tabbar
          :fixed="true"
          style="background: #fff; box-shadow: 0px 0px 10px #979797; padding: 0px 0px 10px;"
        >
          <div
            style="width: 88%; height: 45px; padding: 10px 0px 0px; margin: 8px auto; overflow: hidden;"
          >
            <div class="cart_left" @click="isShopCartShow = true">
              <van-badge :content="shopCart.count">
                <svg-icon
                  :style="{
                    width: '34px',
                    height: '34px',
                    filter: `drop-shadow(${sessionStorage.colorCode} 100px 0)`,
                    transform: 'translateX(-100px)'
                  }"
                  iconClass="cart"
                  class="icon"
                />
              </van-badge>
            </div>
            <div class="cart_right">
              <div
                class="fl total_price"
                :style="{ color: sessionStorage.colorCode }"
              >
                {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
              </div>
              <!-- 下单按钮 -->
              <van-button
                :color="sessionStorage.colorCode"
                class="cart_right_btn"
                round
                @click="placeOrder()"
              >
                <!-- {{ $t("Dishes.order") }} -->
                OK
              </van-button>
            </div>
          </div>
        </van-tabbar>
      </van-popup>
      <!-- 底部固定购物车信息 -->
      <van-tabbar
        :fixed="true"
        style="background: #fff; box-shadow: 0px 0px 10px #979797; padding: 0px 0px 10px;"
      >
        <div
          style="width: 88%; height: 45px; padding: 10px 0px 0px; margin: 8px auto; overflow: hidden;"
        >
          <div class="cart_left" @click="isShopCartShow = true">
            <van-badge :content="shopCart.count">
              <svg-icon
                :style="{
                  width: '34px',
                  height: '34px',
                  filter: `drop-shadow(${sessionStorage.colorCode} 100px 0)`,
                  transform: 'translateX(-100px)'
                }"
                iconClass="cart"
                class="icon"
              />
            </van-badge>
          </div>
          <div class="cart_right">
            <div
              class="fl total_price"
              :style="{ color: sessionStorage.colorCode }"
            >
              {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
            </div>
            <!-- 下单按钮 -->
            <van-button
              :color="sessionStorage.colorCode"
              class="cart_right_btn"
              round
              @click="placeOrder()"
            >
              OK
            </van-button>
          </div>
        </div>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dishes: [],
      activeKey: 0,
      actMenus: [],
      isAll: false,
      isShopCartShow: false,
      shopCart: {},
      timer: null
    };
  },
  created() {
    this.getDishes();
    this.getShopCart();
    this.shopNumber();
    // console.log(localStorage.onlyCode)
    // console.log(this.$i18n.locale)
    // console.log(sessionStorage.code)
  },
  watch: {
    // 监听路由对象，一旦变化，执行该函数
    $route: function(to, from) {
      this.getDishes();
      this.getShopCart();
      this.shopNumber();
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.$nextTick(() => {
        this.$el.style.setProperty(
          "--background-color",
          sessionStorage.colorCode
        );
        const stepper = this.$refs.input[0];
        const plusButton = stepper.$el.querySelector(".van-stepper__plus");
        if (plusButton) {
          const style = window.getComputedStyle(plusButton);
          const backgroundColor = style.backgroundColor;
          console.log("Background color:", backgroundColor);
          if (backgroundColor != "rgb(85, 85, 85)") {
            this.timer = clearInterval(this.timer);
            this.timer = null;
            console.log(this.timer);
          }
        } else {
          console.log("Element with class .van-stepper__plus not found");
        }
      });
    }, 1000);
    // setTimeout(() => {
    //   this.$refs.input.forEach(d => {
    //     d.$refs.input.nextElementSibling.style.background =
    //       sessionStorage.colorCode;
    //   });
    // }, 1000);
  },
  computed: {
    priceTotal() {
      return function(arr) {
        var sum = 0;
        for (var i in arr) {
          sum += Number(arr[i]);
        }
        console.log(sum);
        return sum;
      };
    },
    arrShow() {
      return function(arr) {
        var str = "";
        for (var i in arr) {
          str += arr[i] + (i == arr.length - 1 || !arr[i] ? "" : ",");
        }
        return str;
      };
    }
  },
  methods: {
    // 获取全部菜品
    getDishes() {
      this.$axios({
        method: "get",
        url:
          this.$build + "/api/store/" + sessionStorage.storeId + "/takeMenus/in"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            let dishes = [];
            res.data.data.forEach(item => {
              if (item.status == 1) {
                dishes.push(item);
              }
            });
            this.dishes = dishes;
            this.actMenus = this.dishes[this.activeKey].menus;
            if (this.shopCart.data) {
              this.actMenus.forEach(menu => {
                this.shopCart.data.forEach(shop => {
                  if (menu.id === shop.menu_id) {
                    menu.count = shop.number;
                  }
                });
              });
            }
            this.isAll = true;
            // this.getShopCart();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$toast({
          //   type: "fail",
          //   message: this.$t("common.message")
          // });
        });
    },
    // 切换选中栏
    changeKey() {
      this.actMenus = this.dishes[this.activeKey].menus;
      setTimeout(() => {
        this.$refs.input.forEach(d => {
          d.$refs.input.nextElementSibling.style.background =
            sessionStorage.colorCode;
        });
      }, 0);
    },
    // 获取购物车
    getShopCart() {
      this.$axios({
        method: "post",
        url: this.$build + "/api/place/takeShopcart",
        data: {
          code: localStorage.getItem("onlyCode")
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.shopCart = res.data;
            this.shopCart.data.forEach(item => {
              let arr = [];
              if (item.menus_name.length != 0 && item.tags_name) {
                // 套餐偏好重新排版
                item.tags_name.forEach((i, num) => {
                  i.forEach((j, index) => {
                    let list = []; //临时存储
                    if (i.length > 1) {
                      list.push(`(${item.menus_name[num][index]})：`);
                    }
                    if (typeof j == "object") {
                      j.forEach(tag => {
                        list.push(tag);
                      });
                    } else {
                      list.push(j);
                    }
                    i.splice(index, 1, list);
                  });
                });
              } else if (item.menus_name.length == 0 && item.tags_name) {
                // 单品偏好重新排版
                if (item.tags_name[0] != "") {
                  item.tags_name.forEach(i => {
                    i.forEach(j => {
                      console.log(j);
                      if (typeof j == "object") {
                        j.forEach(tag => {
                          arr.push(tag);
                        });
                      } else {
                        arr.push(j);
                      }
                    });
                  });
                }
                item.tags_name = arr;
              }
            });
            this.shopNumber();
          } else {
            // for (var item in res.data.error) {
            //   this.$toast({
            //     duration: 1000,
            //     type: "fail",
            //     message: res.data.error[item]
            //   });
            // }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 增加商品
    addShopCart(id) {
      this.$axios({
        method: "PATCH",
        url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
        data: {
          type: "add"
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 减少商品
    subShopCart(id, number) {
      if (number == 1) {
        this.$dialog
          .confirm({
            title: this.$t("Dishes.del"),
            message: this.$t("Dishes.isDel"),
            confirmButtonColor: "#FFC813",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "PATCH",
              url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
              data: {
                type: "reduce"
              }
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  this.getShopCart();
                  this.getDishes();
                } else {
                  this.$toast.allowMultiple();
                  for (var item in res.data.error) {
                    this.$toast({
                      duration: 1000,
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  duration: 1000,
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$axios({
          method: "PATCH",
          url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
          data: {
            type: "reduce"
          }
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.getShopCart();
              this.getDishes();
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  duration: 1000,
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              duration: 1000,
              type: "fail",
              message: this.$t("common.message")
            });
          });
      }
    },
    // 菜品列表加减-加菜
    addDish(id, index, number) {
      this.$axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/shopcart/takeCreated",
        data: {
          code: localStorage.getItem("onlyCode"),
          menu_id: id,
          number
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
            // this.actMenus[index].count = this.actMenus[index].count+1;
            this.$toast({
              type: "success",
              message: res.data.message,
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
                duration: 1000
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$toast({
          //   type: "fail",
          //   message: this.$t("common.message"),
          //   duration: 1000
          // });
        });
    },
    // 菜品列表加减-减菜
    subDish(id, index, number) {
      this.$axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/shopcart/takeReduced",
        data: {
          code: localStorage.getItem("onlyCode"),
          menu_id: id,
          number
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
            // this.actMenus[index].count = this.actMenus[index].count-1;
            this.$toast({
              type: "success",
              message: res.data.message,
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
                duration: 1000
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message"),
            duration: 1000
          });
        });
    },
    // 输入框聚焦时触发
    focusDish(e) {
      let obj = e.srcElement;
      obj.focus();
      const len = obj.value.length;
      setTimeout(() => {
        obj.selectionStart = obj.selectionEnd = len;
      }, 60);
    },
    // 输入框失焦时触发
    blurDish(id, index, count) {
      let beforeCount = 0;
      if (this.shopCart.data) {
        this.shopCart.data.forEach(i => {
          if (i.menu_id == id) {
            beforeCount = i.number;
          }
        });
      }
      if (count > 0) {
        if (beforeCount > count) {
          this.subDish(id, index, beforeCount - count);
        } else if (beforeCount < count) {
          this.addDish(id, index, count - beforeCount);
        } else {
          return;
        }
      } else if (count == 0) {
        this.actMenus[index].count = 0;
        this.subDish(id, index, beforeCount - 1);
        this.subDish(id, index, 1);
      } else {
        this.shopNumber();
      }
    },
    isInShopCart(id) {
      var val = 0;
      if (this.shopCart.data) {
        for (var i = 0; i < this.shopCart.data.length; i++) {
          if (id == this.shopCart.data[i].menu_id) {
            val += this.shopCart.data[i].number;
          }
        }
      }
      return val;
    },
    // 下单
    placeOrder() {
      this.$axios({
        method: "PATCH",
        url: this.$build + "/api/place/takeOrder",
        data: {
          code: localStorage.getItem("onlyCode"),
          store_id: sessionStorage.storeId,
          type: "1"
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            localStorage.setItem("takeOrderId", res.data.id);
            var vm = this;
            setTimeout(() => {
              vm.$router.push("/PackOrderDetail/" + res.data.id);
            }, 500);

            localStorage.setItem(
              "successCode",
              localStorage.getItem("onlyCode")
            );
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    shopNumber() {
      console.log(this.shopCart.data);
      if (this.shopCart.data) {
        this.actMenus.forEach(menu => {
          this.shopCart.data.forEach(shop => {
            if (menu.id === shop.menu_id) {
              menu.count = shop.number;
            }
          });
        });
      }
    },
    // 清空购物车
    chearShopcart() {
      this.$axios({
        method: "DELETE",
        url: this.$build + "/api/shopcart/takeClear",
        data: {
          code: localStorage.getItem("onlyCode")
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
            this.$toast({
              type: "success",
              message: res.data.message,
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-field .van-icon {
  font-size: 20px;
}
/deep/ .van-field__value {
  font-size: 16px;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-sidebar {
  width: 25%;
  height: calc(100% - 3.125rem);
  padding-bottom: 3.125rem;
  background-color: #bbbbbb;
  float: left;
  overflow: auto;
  position: relative;
}
/deep/ .van-sidebar-item {
  text-align: center;
  padding: 10px 10px 10px 8px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  margin: 15px 10px 15px 0px;
  border-radius: 0px 50px 50px 0px;
}
/deep/.van-sidebar-item--select::before {
  background: none;
}
/deep/ .van-sidebar-item--select {
  color: #fff;
  border-color: #000;
  background-color: #000;
}
/deep/ .van-dropdown-menu__bar {
  width: 120px;
  height: auto;
  background: none;
}
/deep/ .van-dropdown-menu__title {
  color: #fff;
}
/deep/ .van-dropdown-menu__title::after {
  right: -14px;
  margin-top: -10px;
  border: 6px solid;
  border-color: transparent transparent #ffffff #ffffff;
  opacity: 0.7;
}
/deep/ .van-dropdown-menu__title--down::after {
  margin-top: -2px;
}
/deep/ .van-divider {
  border-width: 2px;
}
/deep/ .van-info {
  border-color: #000;
}
/deep/ .van-popup--center {
  border-radius: 10px;
  border: none;
  overflow: hidden;
}
/deep/ .van-field__label {
  width: auto;
}
/deep/ .van-field__label {
  display: flex;
  align-items: center;
}
/deep/ .van-field__left-icon {
  display: flex;
  align-items: center;
}
/deep/ .van-stepper__minus--disabled,
.van-stepper__plus--disabled {
  background-color: #bbbbbb;
  border-radius: 7px;
}
/deep/ .van-stepper__input {
  background: none;
}
/deep/ .van-stepper__plus {
  border-radius: 7px;
}
/deep/ .van-stepper__minus::before {
  color: #fff;
  height: 2px;
}
/deep/ .van-stepper__plus::before {
  color: #fff;
  height: 2px;
}
/deep/ .van-stepper__plus::after {
  color: #fff;
  width: 2px;
}
/deep/ .van-stepper__minus {
  background-color: #bbbbbb;
  border-radius: 7px;
}
/deep/ .van-nav-bar__right .van-nav-bar__text {
  color: #fff;
  border: 1px solid #fff;
  padding: 5px 10px;
  border-radius: 5px;
}
/deep/ .van-stepper__plus {
  background-color: var(--background-color, #555);
}
.van-button__text {
  color: #fff;
}
.contentWrapper {
  padding-top: 46px;
}
.home {
  width: 100%;
  background-color: #f3f3f3;
}
.shopTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px 10px;
  background-color: #fff;
  width: calc(100% - 20px);
  max-width: 470px;
}
.shopTitle span {
  margin-left: 10px;
  font-size: 18px;
  font-weight: 600;
}
.Bigfont {
  width: 80%;
  font-size: 17px;
  font-weight: 600;
}
.Subname {
  width: 80%;
  font-size: 12px;
  color: #bbbbbb;
  margin-top: 2px;
}
.noflex {
  width: 70px;
  height: 70px;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
}
.menuContent {
  width: 100%;
  height: calc(100vh - 96px);
  flex: auto;
  margin-bottom: 55px;
}
.menuContent1 {
  width: 100%;
  height: calc(100vh - 132px);
  flex: auto;
}
.dishContent {
  width: 75%;
  height: calc(100% - 3.125rem);
  padding-bottom: 3.125rem;
  float: right;
  overflow: hidden;
  overflow-y: auto;
  margin-top: 2px;
  background-color: #fff;
}
.dishItem {
  width: calc(100% - 16px);
  margin: 10px 20px;
  height: 100px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  display: flex;
  overflow: hidden;
  align-items: center;
}
.itemInfo {
  flex: auto;
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
  width: 100px;
}
.leftInfo {
  margin-left: 10px;
  width: 100%;
  min-height: 5rem;
  font-size: 14px;
}
.fontLine {
  overflow: hidden;
  word-break: break-all;
}
.price_num {
  width: 100%;
}
.icons {
  display: flex;
  width: 100%;
}
.itemIcon {
  text-align: right;
}
.enterIcon {
  position: absolute;
  top: 10px;
  right: 10px;
}
.flexBox {
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.flexNone {
  flex: none;
}
.currentPrice {
  color: #fc1617;
  font-size: 18px;
  font-weight: 600;
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.cart_left {
  width: 60%;
  height: 34px;
  line-height: 34px;
  float: left;
}
.cart_right {
  width: 40%;
  height: 34px;
  line-height: 26px;
  float: right;
  text-align: right;
  display: flex;
  justify-content: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #222;
  padding: 5px 35px;
  font-weight: 600;
  font-size: 18px;
}
.total_price {
  height: 34px;
  line-height: 34px;
  text-indent: 10px;
  font-size: 20px;
  font-weight: 600;
  text-align: right;
  margin-right: 10px;
}
.cartHeader {
  width: 100%;
  position: fixed;
  background: #fff;
  z-index: 10;
}
.cartDetail {
  width: 100%;
  height: auto;
  margin-top: 50px;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  position: relative;
}
.leftdot {
  position: absolute;
  width: 6px;
  height: 6px;
  left: -3.5%;
  top: 15px;
  background: linear-gradient(to right, #ffc914, #ffc813);
  border-radius: 50%;
}
.cart_dish {
  width: 100%;
  overflow: hidden;
}
.cart_dish_name {
  width: 80%;
  height: 50px;
  line-height: 50px;
  text-indent: 5px;
}
.cart_dish_icon {
  width: 80%;
  height: 40px;
  line-height: 40px;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.dish {
  display: flex;
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.icon_group {
  height: 35px;
  line-height: 35px;
}
.realPrice {
  color: #fb2525;
  font-weight: 600;
}
.detailBar {
  width: 100%;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #222;
  background-color: #ffc914;
  border-bottom: 1px solid #f3f3f3;
  position: relative;
  /* padding-top: 46px; */
}
.rightIcon {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dishItem_footer {
  width: 100%;
  display: flex;
}
.right_navbar {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.right_navbar .van-button {
  margin-right: 30px;
}
.reduceBtn,
.addBtn {
  border-radius: 8px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/packDishes/PackDishes.vue